<template src="./Fechamento.html"></template>

<script>
  import { mapMutations } from "vuex";  
  import moment from "moment";  
  import usuario from "@/services/usuario";
  import clienteCtrl from "@/services/cliente";
  import emailControl from "@/services/email";

  export default {
    data () {
      return {
        valid: true,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        user: {name: '', acesso: ''},
        dialogConfirmationEmail:false,
        dialogConfirmation:false,
        dialogError: false,
        dialogParcela: false,
        editando: false,
        message: "",
        search: "",
        excluindo: {},
        filtros: {},
        clientes: [],
        valorTotalRecebido: 0,
        mesAtual: 0,
        mesPassado: 0,
        headers: [{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: '_id.clienteNome'
          },{
            text: 'Email',
            align: 'left',
            sortable: true,
            value: '_id.clienteEmail'
          },{
            text: 'Valor Fechamento',
            align: 'left',
            sortable: true,
            value: 'valorCliente'
          },
          { text: 'Ações', value: 'action', sortable: false },
        ]
      }
    },
    async created () {
      await this.buscar();
    },
    methods: {
      
      buscar: async function () {
        this.setLoading(true);
        this.user = await usuario.getUsuario(this.$store.getters.user._id);
        this.clientes = await clienteCtrl.getClientesValores({date: this.date});
        this.setLoading(false);
      },
      confirmEmail (item) {
        this.model = item;
        this.dialogConfirmationEmail = true;
      },
      async enviarEmail (item) {
        this.setLoading(true);
        await emailControl.sendMessageCliente(item);
        this.dialogEmail = false;
        this.model = {};
        this.setLoading(false);
        this.dialogConfirmationEmail = false;
        this.setError('Email enviado com sucesso!');
      },
      ...mapMutations({
        setLoading : "setLoading",
        setError: "setError",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/fechamento/Fechamento.vue